<template>
  <div class="slide" :id="id" v-show="active">
    <slot></slot>
    <hr />
  </div>
</template>

<script>
import inViewport from 'vue-in-viewport-mixin'

export default {
  mixins: [inViewport],
  data () {
    return {
      id: Math.random().toString(36).slice(2),
      active: true
    }
  }
}
</script>

<style>
  hr {
    border-bottom: 1px solid #000;
  }
  .slide {
    padding-bottom: 80px;
  }
</style>



// WEBPACK FOOTER //
// Slide.vue?7a3af24e